import { useMemo } from "react";

import useStorage from "fe-shared/src/hooks/useStorage";
import {
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";

import getRequestParams, { DEFAULT_SORT_FIELD } from "helpers/requestConverter";

const useRequestsParams = () => {
  const [options, setOptions] = useStorage<DataGridOptions>(
    "portalRequestsOptions",
    {
      sortDirection: "desc",
      sortField: DEFAULT_SORT_FIELD,
    },
    true
  );
  const [filters, setFilters] = useStorage<DataGridFilters>(
    "portalRequestsFilters",
    {},
    true
  );

  const requestParams = useMemo(() => getRequestParams(filters, options), [
    filters,
    options,
  ]);

  return {
    options,
    filters,
    setOptions,
    setFilters,
    requestParams,
  };
};

export default useRequestsParams;
